import { Injectable } from "@angular/core";
import { ADMIN_API_URL } from "src/app/config/config";
import { HttpClient } from "@angular/common/http";
import { Item } from "src/app/models/item.model";
import { ImagesService } from "../uploadfiles/images.service";
import { Signal } from "../../models/signal.model";
import { Forex } from "../../models/forex.model";
import { Subject, Subscription } from "rxjs";
import { AngularFirestore } from '@angular/fire/firestore';
import { switchMap, tap } from 'rxjs/operators';



@Injectable({
  providedIn: "root",
})
export class ItemService {
  public lang = new Subject<string>();
  public langSub = this.lang.asObservable();
  public langSelected: any;
  constructor(public http: HttpClient, public imageService: ImagesService,    private firestore: AngularFirestore // Include AngularFirestore in the constructor
  ) {}

  getItems(tag: string, hashkey: string) {
    let url = "";

    if (tag === "signal") {
      url = ADMIN_API_URL + `/${tag}s?businessId=${this.langSelected}`;
    } else if (tag === "forex") {
      url = ADMIN_API_URL + `/signals/${tag}?businessId=${this.langSelected}`;
    } else {
      url = ADMIN_API_URL + `/items/tag/${tag}`;
    }
    return this.http.get(url);
  }

  getContacts() {
    const url = ADMIN_API_URL + `/contacts?businessId=root`;

    return this.http.get(url);
  }

  searchItemByName(searchKey: string, tag: string) {
    const url =
      ADMIN_API_URL +
      "/items" +
      '?name=["bw","' +
      searchKey +
      '"]&hasTags=' +
      tag;

    return this.http.get(url);
  }

  searchItemByTag(searchKey: string, tag: string) {
    const url =
      ADMIN_API_URL +
      "/items" +
      '?name=["eq","' +
      searchKey +
      '"]&tags=["eq","' +
      tag +
      '"]';

    return this.http.get(url);
  }

  searchItemsCategory(searchKey: string) {
    const url =
      ADMIN_API_URL + "/items" + '?category=["eq","' + searchKey + '"]';

    return this.http.get(url);
  }

  postItem(item: Item) {
    const url = `${ADMIN_API_URL}/items`;
    const itemId = item.itemId; // Assuming itemId is the document ID in Firestore


    const body = {
      businessId: "root",
      name: item.name,
      category: item.category,
      description: item.description,
      tags: item.tags,
      stream_url: item.stream_url,
      clickMe: item.clickMe,
      item_picture: item.item_picture,
      section: item.section ? item.section : null,
      isMembersOnly: item.isMembersOnly ? item.isMembersOnly : false,
      isGoldPlan: item.isGoldPlan ? item.isGoldPlan : false,
    };
    return this.http.post(url, body);
  }

  postVideoItem(item: Item) {
    const url = `${ADMIN_API_URL}/items`;
    const youtube = item.video_url.includes('youtube')
    let videoURL = item.video_url;

    if (youtube) {
      videoURL=item.video_url + "&";
    } 

    const body = {
      businessId: "root",
      name: item.name,
      category: item.category,
      description: item.description,
      stream_url: item.stream_url,
      clickMe: item.clickMe,
      tags: item.tags,
      video_url: videoURL,
      section: item.section ? item.section : null,
 
    };
    return this.http.post(url, body);
  }

  postEventItem(item: Item) {
    const url = ADMIN_API_URL + "/items";
    
    const body = {
      businessId: "root",
      name: item.name,
      category: item.category,
      description: item.description,
      tags: item.tags,
      stream_url: item.stream_url,
      clickMe: item.clickMe,
      item_picture: item.item_picture,
    };
    return this.http.post(url, body);
  }

  putEventItem(item: Item) {
    console.log(item);
    const url = ADMIN_API_URL + "/items";
    const body = {
      businessId: "root",
      id: item.itemId,
      name: item.name,
      description: item.description,
      stream_url: item.stream_url,
      clickMe: item.clickMe,
      isMembersOnly: item.isMembersOnly ? item.isMembersOnly : false,
      isGoldPlan: item.isGoldPlan ? item.isGoldPlan : false,
    };
    return this.http.put(url, body);
  }

  putItem(item: Item) {

    const url = ADMIN_API_URL + "/items";

    const itemId = item.itemId; // Assuming itemId is the document ID in Firestore

    const itemRef = this.firestore.collection('businesses').doc('root').collection('items').doc(itemId);
    const dataToUpdate = {
      isMembersOnly: item.isMembersOnly ? item.isMembersOnly : false,
      isGoldPlan: item.isGoldPlan ? item.isGoldPlan : false,
    };
    try {
       itemRef.set(dataToUpdate, { merge: true });
      console.log("Firestore document successfully updated!");
    } catch (error) {
      console.error("Error updating Firestore document: ", error);
    }

    const body = {
      businessId: "root",
      id: item.itemId,
      name: item.name,
      description: item.description,
      stream_url: item.stream_url,
      clickMe: item.clickMe,

    };
    console.log("Item to be updated:", body);
    console.log("PUT Request Body:", body);
    return this.http.put(url, body);
  }

  
  

  putSignal(signal: Signal) {
    console.log(signal);
    const url = ADMIN_API_URL + "/signals";
    const body = {
      businessId: "root",
      id: signal.signalId,
      status: signal.status,
      color: signal.color,
      stopLoss: signal.stopLoss,
    };
    return this.http.put(url, body);
  }

  putForexSignal(signal: Forex) {
    console.log(signal);
    const url = ADMIN_API_URL + "/signals/forex";
    const body = {
      businessId: "root",
      id: signal.signalId,
      status: signal.status,
      color: signal.color,
      stopLoss: signal.stopLoss,
    };
    return this.http.put(url, body);
  }

  putVideoItem(item: Item) {
    const url = ADMIN_API_URL + "/items";
    const youtube = item.video_url.includes('youtube')
    let videoURL = item.video_url;
  
    if (youtube) {
      videoURL = item.video_url + "&";
    }
  
    const body = {
      businessId: "root",
      id: item.itemId,
      name: item.name,
      description: item.description,
      video_url: videoURL,
      clickMe: item.clickMe,
    };
  
    console.log("Item to be updated:", body);
    console.log("PUT Request Body:", body);
    
    return this.http.put(url, body);
  }
  
  async updateMembershipForItem(item: Item) {
    const itemId = item.itemId; // Assuming itemId is the document ID in Firestore
    const itemRef = this.firestore.collection('businesses').doc('root').collection('items').doc(itemId);
    const dataToUpdate = {
      isMembersOnly: item.isMembersOnly ,
      isGoldPlan: item.isGoldPlan,
    };
    console.log(dataToUpdate)
    try {
      await itemRef.set(dataToUpdate, { merge: true });
      console.log("Firestore document successfully updated!");
    } catch (error) {
      console.error("Error updating Firestore document: ", error);
    }
  }
  postAndSetMembership(item: Item) {
    console.log(item)
    return this.postItem(item).pipe(
      switchMap(() => this.updateMembershipForItem(item))
    );
}
  // Call putVideoItem followed by updateMembershipForItem sequentially
  putAndSetMembership(item: Item) {
    return this.putVideoItem(item).pipe(
      switchMap(() => this.updateMembershipForItem(item))
    );
  }
  putAndSetMembershipVideo(item: Item) {
    return this.putItem(item).pipe(
      switchMap(() => this.updateMembershipForItem(item))
    );
  }

  deleteItem(searchKey: string) {
    const url = ADMIN_API_URL + `/items?businessId=root&id=${searchKey}`;

    return this.http.delete(url);
  }

  deleteSignal(searchKey: string) {
    const url = ADMIN_API_URL + `/signals?businessId=root&id=${searchKey}`;

    return this.http.delete(url);
  }

  deleteSignalForex(searchKey: string) {
    const url =
      ADMIN_API_URL + `/signals/forex?businessId=root&id=${searchKey}`;

    return this.http.delete(url);
  }

  uploadFile(file: any, tag: any) {
    const Name = file.name;
    // const type = file.type;
    const fileparts = Name.split(".");
    const date = new Date();
    const dateString = date.toISOString().replace(/[\.\-:]/g, "");
    let filePath = "";
    if (tag === "forex") {
      filePath =
        "images/signals/" +
        tag +
        "/" +
        fileparts[0] +
        dateString +
        "." +
        fileparts[1];
    } else {
      filePath =
        "images/items/" +
        tag +
        "/" +
        fileparts[0] +
        dateString +
        "." +
        fileparts[1];
    }

    return new Promise(async (resolve, reject) => {
      await this.imageService
        .uploadImage(filePath, file)
        .then((res: any) => {
          resolve(res);
        })
        .catch((res) => {
          console.log(res);
          reject(res);
        });
    });
  }
}
